export default {"src":"/_next/static/image/src/images/onboarding/box.1a1b513caad4b865d9fd9d4eddc3a36e.svg","height":88,"width":88};